import React from 'react'
import agent from '../agent'
import Loading from './widgets/Loading'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { COIN_TRANSACTION_PAGE_LOADED, COIN_TRANSACTION_PAGE_UNLOADED } from '../constants/actionTypes'
import dateHelper from '../util/dateFormatter'
import numberHelper from '../util/numberFormatter'

const mapStateToProps = state => ({
  ...state.coins,
  currentUser: state.common.currentUser
});

const mapDispatchToProps = dispatch => ({
  onLoad: payload =>
    dispatch({ type: COIN_TRANSACTION_PAGE_LOADED, payload }),
  onUnload: () =>
    dispatch({ type: COIN_TRANSACTION_PAGE_UNLOADED })
});

class CoinTransactionDetail extends React.Component {
  componentWillMount() {
    this.props.onLoad(
      agent.Coins.transactionDetail(this.props.match.params.key)
    );
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  render() {
    if (!this.props.transaction) {
      return (
        <Loading />
      )
    }
    return (
      <div class='pane'>
        <Link className="crumb" to={`/coins`}>&laquo; back to coins</Link>

        <h1>Transaction Detail</h1>
        <div className="infoGroup">
          <div className="infoPair">
            <label>Key:</label> <span>{this.props.transaction.key}</span>
          </div>
          <div className="infoPair">
            <label>Type:</label> <span>{this.props.transaction.type}</span>
          </div>
          <div className="infoPair">
            <label>Time:</label> <span>{dateHelper.Formatter.toLocalString(this.props.transaction.created)}</span>
          </div>
          {
            this.props.transaction.sender_bank_account ?
              <div className="infoPair">
                <label>Sender :</label> <span>
                  {
                    this.props.transaction.sender_bank_account.user_key.toUpperCase() === 'MASTER' ? this.props.transaction.sender_bank_account.name :
                      <Link to={`/users/${this.props.transaction.sender_bank_account.user_key}`}>{this.props.transaction.sender_bank_account.user_key}</Link>
                  }
                </span>
              </div>
              : null
          }

          <div className="infoPair">
            <label>Sender Address:</label> <span>{this.props.transaction.sender_account}</span>
          </div>
          {
            this.props.transaction.recipient_bank_account ?
              <div className="infoPair">
                <label>Recipient :</label> <span>
                  {
                    this.props.transaction.recipient_bank_account.user_key.toUpperCase() === 'MASTER' ? this.props.transaction.recipient_bank_account.name :
                      <Link to={`/users/${this.props.transaction.recipient_bank_account.user_key}`}>{this.props.transaction.recipient_bank_account.user_key}</Link>
                  }
                </span>
              </div>
              : null
          }

          <div className="infoPair">
            <label>Recipient Address:</label> <span>{this.props.transaction.recipient_account}</span>
          </div>
          <div className="infoPair">
            <label>Symbol:</label> <span>{this.props.transaction.symbol}</span>
          </div>
          <div className="infoPair">
            <label>Amount:</label> <span>{numberHelper.Formatter.toDecimal(this.props.transaction.amount)}</span>
          </div>
          <div className="infoPair">
            <label>Notes:</label> <span>{this.props.transaction.notes || ''}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CoinTransactionDetail);



// WEBPACK FOOTER //
// ./src/components/CoinTransactionDetail.js